var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowLeaderBoardBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 715,
    height: 890,
    viewBox: "0 0 715 890",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2004_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.334 354.053C236.111 405.852 274.14 447.752 313.757 475.718C353.373 503.684 393.242 516.772 429.522 513.723C465.803 510.673 497.272 491.588 520.897 458.307C544.523 425.025 559.509 378.669 564.412 323.703L334.56 150.002L203.334 354.053Z",
    fill: "#FF7A00",
    fillOpacity: 0.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2004_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 579.735C182.777 631.533 220.806 673.434 260.423 701.4C300.039 729.366 339.908 742.454 376.188 739.405C412.469 736.355 443.938 717.27 467.563 683.989C491.189 650.707 506.175 604.351 511.078 549.385L281.226 375.684L150 579.735Z",
    fill: "#B639CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2004_10",
    x: 53.334,
    y: 0.00189209,
    width: 661.078,
    height: 664.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2004_10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2004_10",
    x: 0,
    y: 225.684,
    width: 661.078,
    height: 664.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2004_10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowLeaderBoardBlock);
export default __webpack_public_path__ + "static/media/shadowLeaderBoardBlock.1f8d3be9673cdf1f92af497d5c3ff61c.svg";
export { ForwardRef as ReactComponent };